import './typing.scss';

import {FunctionalComponent, h } from "preact";
import {useEffect} from "preact/hooks";
import {MessageFrame} from "../../components/messageFrame";

const Typing: FunctionalComponent<{msgID: string; duration: number; tickCallback: () => void}> = ({msgID, duration, tickCallback}) => {

    useEffect(() => {
        if (duration === -1) {
          // INTERRUPTABLE TYPING MESSAGE, make queue immediately advance: typing won't be removed until next message arrives
          tickCallback();
          return;
        }
        window.setTimeout(tickCallback, duration);
        /** advance queue */
    }, [msgID]);


    return (<MessageFrame clsName='typing'>
      <p>
        <div className="loader-inner ball-pulse">
          <div />
          <div />
          <div />
        </div>
      </p>
    </MessageFrame>);
}

export default Typing;
